import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { AnalyseStatut } from 'src/app/domain/Analyse/enum/analyse-statut';
import { Taxon } from 'src/app/domain/Analyse/taxon';
import { IBMRProcess } from 'src/app/domain/IBMR/IBMR-process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { User } from 'src/app/domain/planning/user';
import { Document } from 'src/app/domain/Shared/document';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { AnalyseService } from 'src/app/services/analyse-service';
import { DocumentService } from 'src/app/services/document.service';
import { ExportService } from 'src/app/services/export.service';
import { IBMRService } from 'src/app/services/ibmr.service';
import { InterventionService } from 'src/app/services/intervention.services';
import { TaxonService } from 'src/app/services/taxon-service';
import { UserService } from 'src/app/services/user-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { TaxonDialogModel } from 'src/app/tools/ui/taxon-dialog/taxon-dialog-model';
import { TaxonDialogComponent } from 'src/app/tools/ui/taxon-dialog/taxon-dialog.component';

@Component({
    selector: 'app-analysis',
    templateUrl: './analysis.component.html',
    styleUrls: ['./analysis.component.scss']
})
export class AnalysisComponent implements OnInit, AfterContentInit {
    EInterventionType = EInterventionType;
    AnalyseStatut = AnalyseStatut;
    @ViewChild('analyste') analyste: ElementRef<HTMLInputElement>;
    @ViewChild('trieur') trieur: ElementRef<HTMLInputElement>;
    public model: Analyse = new Analyse();

    // IBMR ONLY
    private intervention: Intervention;
    private ibmrProcess: IBMRProcess;
    //
    public AllUserList: User[] = [];
    public PhaseList: number[] = [];
    private lastSelectedPhase: number;

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    addOnBlur = true;
    selectable = true;
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save',
            },
            {
                Id: 1,
                Text: undefined,
                Icon: 'done',
            },
            {
                Id: 2,
                Text: undefined,
                Icon: 'add',
            },
            {
                Id: 3,
                Text: undefined,
                Icon: 'description',
            },
            {
                Id: 4,
                Text: undefined,
                Icon: 'library_add',
            },
        ];

    constructor(
        public coreData: CoreData,
        private exportService: ExportService,
        private interventionService: InterventionService,
        private analysisService: AnalyseService,
        private ibmrService: IBMRService,
        private taxonService: TaxonService,
        private userService: UserService,
        private documentService: DocumentService,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog) { }

    ngOnInit(): void {
    }

    computeHeterotrophes() {
        return this.model.TaxonList.find(x => x.NomFamille?.includes('HETEROTROPHES') && x.NumeroPhase === 1)?.Quantite * this.ibmrProcess.IBMRUniteReleve1.Recouvrement / 100 +
            this.model.TaxonList.find(x => x.NomFamille?.includes('HETEROTROPHES') && x.NumeroPhase === 2)?.Quantite * this.ibmrProcess.IBMRUniteReleve2.Recouvrement / 100
    }

    computeAlgues() {
        return this.model.TaxonList.find(x => x.NomFamille?.includes('ALGUES') && x.NumeroPhase === 1)?.Quantite * this.ibmrProcess.IBMRUniteReleve1.Recouvrement / 100 +
            this.model.TaxonList.find(x => x.NomFamille?.includes('ALGUES') && x.NumeroPhase === 2)?.Quantite * this.ibmrProcess.IBMRUniteReleve2.Recouvrement / 100
    }

    computeBryophytes() {
        return this.model.TaxonList.find(x => x.NomFamille?.includes('BRYOPHYTES') && x.NumeroPhase === 1)?.Quantite * this.ibmrProcess.IBMRUniteReleve1.Recouvrement / 100 +
            this.model.TaxonList.find(x => x.NomFamille?.includes('BRYOPHYTES') && x.NumeroPhase === 2)?.Quantite * this.ibmrProcess.IBMRUniteReleve2.Recouvrement / 100
    }

    computePteridophytes() {
        return this.model.TaxonList.find(x => x.NomFamille?.includes('PTERIDOPHYTES') && x.NumeroPhase === 1)?.Quantite * this.ibmrProcess.IBMRUniteReleve1.Recouvrement / 100 +
            this.model.TaxonList.find(x => x.NomFamille?.includes('PTERIDOPHYTES') && x.NumeroPhase === 2)?.Quantite * this.ibmrProcess.IBMRUniteReleve2.Recouvrement / 100
    }

    computePhanerogames() {
        return this.model.TaxonList.find(x => x.NomFamille?.includes('PHANEROGAMES') && x.NumeroPhase === 1)?.Quantite * this.ibmrProcess.IBMRUniteReleve1.Recouvrement / 100 +
            this.model.TaxonList.find(x => x.NomFamille?.includes('PHANEROGAMES') && x.NumeroPhase === 2)?.Quantite * this.ibmrProcess.IBMRUniteReleve2.Recouvrement / 100
    }

    ngAfterContentInit(): void {
        if (!this.route.snapshot.params.interventionCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        if (this.coreData.IsOffline) {
            this.FabOptions = this.FabOptions.filter(x => x.Id === 2);
            this.model = this.coreData.getOfflineAnalyse(this.route.snapshot.params.interventionCode);
            this.intervention = this.coreData.getOfflineIntervention(this.route.snapshot.params.interventionCode);
            this.model.MergedTaxonList = this.generateUnflateTaxonList();
            this.ibmrProcess = this.coreData.getOfflineProcess(this.intervention.ProcessCode) as IBMRProcess;
        } else {
            this.interventionService.getInterventionDetails(this.route.snapshot.params.interventionCode).subscribe(async x => {
                this.intervention = x;
                if (this.intervention.Type === EInterventionType.IBMR) {
                    await this.getProcessFromServer(this.intervention.ProcessCode);
                }
            });
            this.getAnalyseFromServer();
            this.getAvailableUserList();
        }
        this.lastSelectedPhase = 1;
    }

    async getProcessFromServer(processCode: string) {

        await new Promise((resolve, reject) => {
            this.ibmrService.getProcessByCode(processCode).subscribe(x => {
                this.ibmrProcess = x;
                resolve(true);
            });
        })
    }

    getAnalyseFromServer() {
        this.analysisService.getAnalyseByIntervention(this.route.snapshot.params.interventionCode).subscribe(x => {
            this.model = x;

            if (this.model.Type === EInterventionType.IBD || this.model.Type === EInterventionType.LAC) {
                _.remove(this.FabOptions, x => x.Id === 2);
            }
            for (let i = 1; i <= this.model.NombrePhase; i++) {
                this.PhaseList.push(i);
            }
            // UNFLATE TAXON LIST
            this.model.MergedTaxonList = this.generateUnflateTaxonList();
            if (this.model.Type !== EInterventionType.IBD) {
                this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                    function (item) { return item.Position; },
                    function (item) { return item.NomFamille; },
                    function (item) { return item.NomGenre; }
                ]);
            } else {
                this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                    function (item) { return -item.Quantite; },
                    function (item) { return item.NomFamille; }
                ]);
            }
        });
    }

    generateUnflateTaxonList() {
        const list: Taxon[] = [];
        this.model.TaxonList.forEach(x => {
            let tax: Taxon;
            if (!list.includes(list.find(t => t.SandreCode === x.SandreCode))) {
                tax = Object.assign({}, x);
                this.initQuantity(tax);
                list.push(tax);
            } else {
                tax = list.find(t => t.SandreCode === x.SandreCode);
            }

            this.setQuantity(tax, x.Quantite, x.NumeroPhase, x.NumeroTransect, x);
        });

        return list;
    }

    getLabelForSorter() {
        if (this.model.Type === EInterventionType.IBD) {
            return 'Préparateurs lame...';
        } else if (this.model.Type === EInterventionType.LAC) {
            return 'Préparateurs sédiments...';
        }

        return 'Trieurs...';
    }

    getLabelForSortingDate() {
        if (this.model.Type === EInterventionType.IBD) {
            return 'Date fin préparation lame';
        } else if (this.model.Type === EInterventionType.LAC) {
            return 'Date fin sédiments...';
        }

        return 'Date du tri';
    }

    getLabelForSortingDuration() {
        if (this.model.Type === EInterventionType.IBD) {
            return 'Durée préparation lame';
        } else if (this.model.Type === EInterventionType.LAC) {
            return 'Durée sédiments...';
        }

        return 'Durée du tri';
    }
    initQuantity(tax: Taxon) {
        tax.Quantite1 = 0;
        tax.Quantite2 = 0;
        tax.Quantite3 = 0;
        tax.Quantite4 = 0;
        tax.Quantite5 = 0;
        tax.Quantite6 = 0;
        tax.Quantite7 = 0;
        tax.Quantite8 = 0;
        tax.Quantite9 = 0;
        tax.Quantite10 = 0;
        tax.Quantite11 = 0;
        tax.Quantite12 = 0;
        tax.Quantite13 = 0;
        tax.Quantite14 = 0;
        tax.Quantite15 = 0;
        tax.Quantite16 = 0;
        tax.Quantite17 = 0;
        tax.Quantite18 = 0;
        tax.Quantite19 = 0;
        tax.Quantite20 = 0;
        tax.QuantitePhaseA = 0;
        tax.QuantitePhaseB = 0;
        tax.QuantitePhaseC = 0;
    }

    setQuantity(tax: Taxon, quantite: number, phaseNum: number, transectNum?: number, exactTaxon?: Taxon) {
        if (this.model.Type === EInterventionType.IBGN) {
            tax.Quantite = quantite;
        } else if (
            this.model.Type === EInterventionType.MPCE ||
            this.model.Type === EInterventionType.MGCE ||
            this.model.Type === EInterventionType.IML) {

            if (this.model.NombrePhase === 3) { // MPCE
                switch (phaseNum) {
                    case 1:
                        tax.QuantitePhaseA = quantite;
                        break;
                    case 2:
                        tax.QuantitePhaseB = quantite;
                        break;
                    case 3:
                        tax.QuantitePhaseC = quantite;
                        break;
                }
            } else {
                switch (phaseNum) { // MGCE 
                    case 1:
                        tax.Quantite1 = quantite;
                        break;
                    case 2:
                        tax.Quantite2 = quantite;
                        break;
                    case 3:
                        tax.Quantite3 = quantite;
                        break;
                    case 4:
                        tax.Quantite4 = quantite;
                        break;
                    case 5:
                        tax.Quantite5 = quantite;
                        break;
                    case 6:
                        tax.Quantite6 = quantite;
                        break;
                    case 7:
                        tax.Quantite7 = quantite;
                        break;
                    case 8:
                        tax.Quantite8 = quantite;
                        break;
                    case 9:
                        tax.Quantite9 = quantite;
                        break;
                    case 10:
                        tax.Quantite10 = quantite;
                        break;
                    case 11:
                        tax.Quantite11 = quantite;
                        break;
                    case 12:
                        tax.Quantite12 = quantite;
                        break;

                    // IML
                    case 13:
                        tax.Quantite13 = quantite;
                        break;
                    case 14:
                        tax.Quantite14 = quantite;
                        break;
                    case 15:
                        tax.Quantite15 = quantite;
                        break;
                }
            }
        } else if (this.model.Type === EInterventionType.IBMR) {
            if (phaseNum === 1)
                switch (transectNum) {
                    case 1:
                        tax.Quantite1 = quantite;
                        tax.Comment1 = exactTaxon.Comment
                        break;
                    case 2:
                        tax.Quantite2 = quantite;
                        tax.Comment2 = exactTaxon.Comment
                        break;
                    case 3:
                        tax.Quantite3 = quantite;
                        tax.Comment3 = exactTaxon.Comment
                        break;
                    case 4:
                        tax.Quantite4 = quantite;
                        tax.Comment4 = exactTaxon.Comment
                        break;
                    case 5:
                        tax.Quantite5 = quantite;
                        tax.Comment5 = exactTaxon.Comment
                        break;
                    case 6:
                        tax.Quantite6 = quantite;
                        tax.Comment6 = exactTaxon.Comment
                        break;
                    case 7:
                        tax.Quantite7 = quantite;
                        tax.Comment7 = exactTaxon.Comment
                        break;
                    case 8:
                        tax.Quantite8 = quantite;
                        tax.Comment8 = exactTaxon.Comment
                        break;
                    case 9:
                        tax.Quantite9 = quantite;
                        tax.Comment9 = exactTaxon.Comment
                        break;
                    case 10:
                        tax.Quantite10 = quantite;
                        tax.Comment10 = exactTaxon.Comment
                        break;
                }
            else if (phaseNum === 2) {
                switch (transectNum) {
                    case 1:
                        tax.Quantite11 = quantite;
                        tax.Comment11 = exactTaxon.Comment
                        break;
                    case 2:
                        tax.Quantite12 = quantite;
                        tax.Comment12 = exactTaxon.Comment
                        break;
                    case 3:
                        tax.Quantite13 = quantite;
                        tax.Comment13 = exactTaxon.Comment
                        break;
                    case 4:
                        tax.Quantite14 = quantite;
                        tax.Comment14 = exactTaxon.Comment
                        break;
                    case 5:
                        tax.Quantite15 = quantite;
                        tax.Comment15 = exactTaxon.Comment
                        break;
                    case 6:
                        tax.Quantite16 = quantite;
                        tax.Comment16 = exactTaxon.Comment
                        break;
                    case 7:
                        tax.Quantite17 = quantite;
                        tax.Comment17 = exactTaxon.Comment
                        break;
                    case 8:
                        tax.Quantite18 = quantite;
                        tax.Comment18 = exactTaxon.Comment
                        break;
                    case 9:
                        tax.Quantite19 = quantite;
                        tax.Comment19 = exactTaxon.Comment
                        break;
                    case 10:
                        tax.Quantite20 = quantite;
                        tax.Comment20 = exactTaxon.Comment
                        break;
                }
            }
        }
    }

    // addAnalyser(event: MatChipInputEvent) {
    //   const input = event.input;
    //   const value = event.value;

    //   // Add our fruit
    //   if ((value || '').trim()) {
    //     this.model.AnalyserList.push(this.AllUserList.find(u => u.Fullname === value.trim()));
    //   }

    //   // Reset the input value
    //   if (input) {
    //     input.value = '';
    //   }
    // }

    // Analyser - analyste
    removeAnalyser(user: User): void {
        const index = this.model.AnalyserList.indexOf(user);

        if (index >= 0) {
            this.model.AnalyserList.splice(index, 1);
        }
    }

    selectedAnalyser(event: MatAutocompleteSelectedEvent) {
        this.model.AnalyserList.push(this.AllUserList.find(u => u.Code === event.option.value.Code));
        this.analyste.nativeElement.value = '';
    }

    // Sorter - Trieur
    removeSorter(user: User): void {
        const index = this.model.SorterList.indexOf(user);

        if (index >= 0) {
            this.model.SorterList.splice(index, 1);
        }
    }

    selectedSorter(event: MatAutocompleteSelectedEvent) {
        this.model.SorterList.push(this.AllUserList.find(u => u.Code === event.option.value.Code));
        this.trieur.nativeElement.value = '';
    }
    compareUser(u1: User, u2: User): boolean {
        return u1.Code === u2.Code;
    }

    getAnalysisStatusName(type: number) {
        return StringConverter.getAnalysisStatusName(type);
    }

    getPhaseLabel(nbPhase: number, index: number) {
        switch (nbPhase) {
            // case 2:
            //     return this.getIBMRPhaseName(index);
            case 4:
                return this.getMGCEPhaseName(index);
            case 12:
            case 15:
                return this.getBullshitPhaseName(index);
        }
    }

    getIBMRPhaseName(phase: number) {
        return `${StringConverter.getIBMRPhaseName(phase)}`;
    }

    getIBMRTransectName(transectNum: number) {
        return `Transect ${transectNum}`;
    }

    getBullshitPhaseName(phase: number) {
        return StringConverter.getBullshitPhaseName(phase);
    }

    getMGCEPhaseName(phase: number) {
        return StringConverter.getMGCEPhaseName(phase);
    }

    getPhaseName(phase: number) {
        return StringConverter.getPhaseName(phase);
    }

    openTaxonDialog(i?: number, it?: number) {
        const taxonDialogModel = new TaxonDialogModel();
        // && x.NumeroPhase === i && x.NumeroTransect === it
        // taxonDialogModel.Taxon = this.model.TaxonList.find(x => x.NumeroPhase === i && x.NumeroTransect === it);
        // taxonDialogModel.AlreadyPickedPhase = [...this.model.TaxonList.filter(t => t.SandreCode === taxon.SandreCode).map(tt => tt.NumeroPhase)];

        taxonDialogModel.Analyse = this.model;
        taxonDialogModel.ProcessCode = this.intervention?.ProcessCode;
        taxonDialogModel.LastSelectedPhase = this.lastSelectedPhase;
        const dialogRef = this.dialog.open(TaxonDialogComponent, { width: '600px', data: taxonDialogModel ? taxonDialogModel : new TaxonDialogModel() });
        dialogRef.afterClosed().subscribe((result: Taxon) => {
            if (result) {

                // if (this.model.Type !== EInterventionType.IBGN) { // TODO What this rules is for ?
                //     if (this.model.TaxonList.find(x => x.SandreCode === result.SandreCode)) {
                //         this.model.TaxonList.find(x => x.SandreCode === result.SandreCode).Comment = result.Comment;
                //     }
                // }
                // if (!taxon) {
                //     this.model.TaxonList.push(result);
                //     this.model.MergedTaxonList.push(result);
                //     this.model.MergedTaxonList = this.generateUnflateTaxonList();

                //     if (this.model.Type !== EInterventionType.IBD) {
                //         this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                //             function (item) { return item.Position; },
                //             function (item) { return item.NomFamille; },
                //             function (item) { return item.NomGenre; }
                //         ]);
                //     } else {
                //         this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                //             function (item) { return -item.Quantite; },
                //             function (item) { return item.NomFamille; }
                //         ]);
                //     }
                //     this.setQuantity(result, result.Quantite, result.NumeroPhase, result.NumeroTransect);
                // } else {
                //     if (this.model.TaxonList.find(x => x.SandreCode === result.SandreCode && x.NumeroPhase === result.NumeroPhase)) {
                //         this.model.TaxonList[_.findIndex(this.model.TaxonList, x => x.SandreCode === result.SandreCode && x.NumeroPhase === result.NumeroPhase)] = result;
                //     } else {
                //         this.model.TaxonList.push(result);
                //     }
                //     if (this.model.MergedTaxonList.find(t => t.SandreCode === taxon.SandreCode)) {
                //         this.setQuantity(taxon, result.Quantite, result.NumeroPhase, result.NumeroTransect);
                //         // taxon.Comment = (this.model.TaxonList.filter(t => t.SandreCode === taxon.SandreCode).map(x => x.Comment)).join('\n')
                //     }
                // }
                if (this.coreData.IsOffline) {
                    this.model = this.coreData.getOfflineAnalyse(this.route.snapshot.params.interventionCode);
                    this.intervention = this.coreData.getOfflineIntervention(this.route.snapshot.params.interventionCode);
                    this.model.MergedTaxonList = this.generateUnflateTaxonList();
                } else {
                    this.getAnalyseFromServer();
                }

                this.lastSelectedPhase = result.NumeroPhase;
            }
        });
    }
    
    openTaxonDialogWithTaxonSelected(tax: Taxon) {
        const taxonDialogModel = new TaxonDialogModel();
        // && x.NumeroPhase === i && x.NumeroTransect === it
        taxonDialogModel.Taxon = tax
        // taxonDialogModel.AlreadyPickedPhase = [...this.model.TaxonList.filter(t => t.SandreCode === taxon.SandreCode).map(tt => tt.NumeroPhase)];

        taxonDialogModel.Analyse = this.model;
        taxonDialogModel.ProcessCode = this.intervention?.ProcessCode;
        taxonDialogModel.LastSelectedPhase = this.lastSelectedPhase;
        const dialogRef = this.dialog.open(TaxonDialogComponent, { width: '600px', data: taxonDialogModel ? taxonDialogModel : new TaxonDialogModel() });
        dialogRef.afterClosed().subscribe((result: Taxon) => {
            if (result) {

                // if (this.model.Type !== EInterventionType.IBGN) { // TODO What this rules is for ?
                //     if (this.model.TaxonList.find(x => x.SandreCode === result.SandreCode)) {
                //         this.model.TaxonList.find(x => x.SandreCode === result.SandreCode).Comment = result.Comment;
                //     }
                // }
                // if (!taxon) {
                //     this.model.TaxonList.push(result);
                //     this.model.MergedTaxonList.push(result);
                //     this.model.MergedTaxonList = this.generateUnflateTaxonList();

                //     if (this.model.Type !== EInterventionType.IBD) {
                //         this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                //             function (item) { return item.Position; },
                //             function (item) { return item.NomFamille; },
                //             function (item) { return item.NomGenre; }
                //         ]);
                //     } else {
                //         this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                //             function (item) { return -item.Quantite; },
                //             function (item) { return item.NomFamille; }
                //         ]);
                //     }
                //     this.setQuantity(result, result.Quantite, result.NumeroPhase, result.NumeroTransect);
                // } else {
                //     if (this.model.TaxonList.find(x => x.SandreCode === result.SandreCode && x.NumeroPhase === result.NumeroPhase)) {
                //         this.model.TaxonList[_.findIndex(this.model.TaxonList, x => x.SandreCode === result.SandreCode && x.NumeroPhase === result.NumeroPhase)] = result;
                //     } else {
                //         this.model.TaxonList.push(result);
                //     }
                //     if (this.model.MergedTaxonList.find(t => t.SandreCode === taxon.SandreCode)) {
                //         this.setQuantity(taxon, result.Quantite, result.NumeroPhase, result.NumeroTransect);
                //         // taxon.Comment = (this.model.TaxonList.filter(t => t.SandreCode === taxon.SandreCode).map(x => x.Comment)).join('\n')
                //     }
                // }
                if (this.coreData.IsOffline) {
                    this.model = this.coreData.getOfflineAnalyse(this.route.snapshot.params.interventionCode);
                    this.intervention = this.coreData.getOfflineIntervention(this.route.snapshot.params.interventionCode);
                    this.model.MergedTaxonList = this.generateUnflateTaxonList();
                } else {
                    this.getAnalyseFromServer();
                }

                this.lastSelectedPhase = result.NumeroPhase;
            }
        });
    }

    getAvailableUserList() {
        this.userService.getAll().subscribe(x => this.AllUserList = x);
    }

    save() {
        this.analysisService.update(this.model).subscribe(x => {
            NotificationManager.handleSuccess(`Analyse mise à jour`, this.snackBar);
        });
    }

    toggleValidation() {
        this.analysisService.finishAnalyse(this.model.Code).subscribe(x => {
            if (x) {
                if (this.model.Status === AnalyseStatut.Done) {
                    NotificationManager.handleSuccess(`En cours d'analyse`, this.snackBar);
                    this.model.Status = AnalyseStatut.InProgress;
                } else {
                    NotificationManager.handleSuccess(`Analyse terminée`, this.snackBar);
                    this.model.Status = AnalyseStatut.Done;
                }
            }
        });
    }

    deletePot(codeSANDRE: number, i: number, it?: number) {

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer le comptage ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (!result)
                return;

            if (this.model.Type === EInterventionType.IBMR) {
                if (this.coreData.IsOffline) {
                    _.remove(this.model.TaxonList, x => x.SandreCode === codeSANDRE && x.NumeroPhase === i && x.NumeroTransect === it);
                    this.coreData.setOfflineAnalyse(this.intervention.Code, this.model);
                    this.model.MergedTaxonList = this.generateUnflateTaxonList();
                } else {

                    this.taxonService.deleteWithTransect(this.model.Code, codeSANDRE, i, it).subscribe(() => {
                        _.remove(this.model.TaxonList, x => x.SandreCode === codeSANDRE && x.NumeroPhase === i && x.NumeroTransect === (x.NumeroPhase - 1 * 10) + it);
                        this.model.MergedTaxonList = this.generateUnflateTaxonList();
                    });
                }
            } else {
                this.taxonService.delete(this.model.Code, codeSANDRE, i).subscribe(() => {
                    // NotificationManager.handleSuccess('Comptage retiré', this.snackBar);
                    this.setQuantity(this.model.MergedTaxonList.find(x => x.SandreCode === codeSANDRE), 0, i, it);
                    _.remove(this.model.TaxonList, x => x.SandreCode === codeSANDRE && x.NumeroPhase === i);

                    if (this.model.Type === EInterventionType.MPCE) {
                        if (this.model.NombrePhase === 3) {
                            if (!this.model.TaxonList.find(y => y.SandreCode === codeSANDRE)) {
                                _.remove(this.model.MergedTaxonList, y => y.SandreCode === codeSANDRE);
                            }
                        } else {
                            if (!this.model.TaxonList.find(y => y.SandreCode === codeSANDRE)) {
                                _.remove(this.model.MergedTaxonList, y => y.SandreCode === codeSANDRE);
                            }
                        }
                    }

                    this.model.MergedTaxonList = this.generateUnflateTaxonList();

                    if (this.model.Type !== EInterventionType.IBD) {
                        this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                            function (item) { return item.Position; },
                            function (item) { return item.NomFamille; },
                            function (item) { return item.NomGenre; }
                        ]);
                    } else {
                        this.model.MergedTaxonList = _.sortBy(this.model.MergedTaxonList, [
                            function (item) { return -item.Quantite; },
                            function (item) { return item.NomFamille; }
                        ]);
                    }
                });
            }
        });
    }

    showComment(comment: string) {
        NotificationManager.handleWarning(comment, this.snackBar)
    }

    generateDraft() {
        this.exportService.generateREDraft(this.model.InterventionCode).subscribe(x => {
            this.exportService.fetchExport(x);
        });
    }

    getDocumentFile(document: Document) {
        this.documentService.getDocument(document.Code).subscribe(x => {
            this.promptFile(x);
        });
    }

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    deleteDocument(taxon: Taxon, edmCode: string) {
        this.documentService.deleteTaxonDocument(edmCode).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Photo supprimée avec succès', this.snackBar);
                taxon.PictureList = _.remove(taxon.PictureList, x => x.Code === taxon.Code);
            }
        });
    }

    openMultipleUploadDialog(isMultiple: boolean = false, taxon?: Taxon) {

        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: {
                code: taxon ? taxon.Code : this.model.Code,
                type: EDocumentType.IBMRTaxonPicture,
                isForImport: false,
                isMultiple: isMultiple
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAnalyseFromServer();
            }
        });
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save();
                break;
            case 1:
                this.toggleValidation();
                break;
            case 2:
                this.openTaxonDialog();
                break;
            case 3:
                this.generateDraft();
                break;
            case 4:
                this.openMultipleUploadDialog(true)
                break;
        }
    }
    // pushAllMyPhotosOfTaxon(files: File[]) {
    //     this.documentService.uploadPhoteDesJolisTaxon(this.model.Code, files).subscribe(x => {
    //         if (x) {
    //             if (typeof (x) === 'boolean') {
    //                 NotificationManager.handleSuccess('Photo asssociées avec succès', this.snackBar);
    //                 // REFRESH ???
    //             } else { // taxon non trouvé ?
    //                 NotificationManager.handleWarning(x, this.snackBar);
    //             }
    //         }
    //     });
    // }
}
